// O que fica só na memória desta aba: a bolha "você enviou" e a composição escolhida.
// Nada vai para localStorage nem para a URL: o texto enviado nunca é persistido (invariante 4).
// Ao recarregar ou abrir pelo histórico ou por link, o fio começa pela alegação em forma neutra.
import { useSyncExternalStore } from "react";

import type { Composicao } from "./composicao";

export interface Enviado {
  texto: string;
  anexo: string | null;
}

const enviados = new Map<string, Enviado>();

/** Guarda o que a pessoa enviou, pelo token do card, até a aba fechar. */
export function lembrarEnvio(token: string, enviado: Enviado) {
  enviados.set(token, enviado);
}

export const envioDe = (token: string): Enviado | undefined => enviados.get(token);

export interface EscolhaModelos {
  composicao: Composicao | null;
  /** O perfil de onde a configuração por etapa começou. */
  base: string | null;
}

let escolha: EscolhaModelos = { composicao: null, base: null };
const ouvintes = new Set<() => void>();

export function escolherModelos(nova: EscolhaModelos) {
  escolha = nova;
  for (const avisar of ouvintes) avisar();
}

/** A composição escolhida vale para os próximos envios desta aba. */
export function useEscolhaModelos(): EscolhaModelos {
  return useSyncExternalStore(
    (avisar) => {
      ouvintes.add(avisar);
      return () => ouvintes.delete(avisar);
    },
    () => escolha,
    () => escolha,
  );
}
